module.exports = __webpack_public_path__ + "img/image21@3x.ceb34ef7.png";